import { ExitModal } from "@components/ui";
import Modal from "@components/ui/Modal";
import ArrowBottom from "assets/svg/arrow-bottom.svg";
import Close from "assets/svg/close.svg";
import Home from "assets/svg/student/navbar/home-04.svg";
import BookIcon from "assets/svg/student/navbar/book-03.svg";
import CardCheckIcon from "assets/svg/student/navbar/card-check.svg";
import UserProfileCheckIcon from "assets/svg/student/navbar/user-profile-check.svg";
import UsersProfilesPlusIcon from "assets/svg/student/navbar/users-profiles-plus.svg";
import cn from "classnames";
import { Button } from "components";
import { useRouter } from "next/router";
import { SEO } from "pages/course-type/[...type]";
import React, { useState } from "react";
import useProfile from "src/hooks/useProfile";
import {
  generateUuidForReactList,
  getNameAndEnumForCourseType,
} from "src/utils";

export interface SidebarProps {
  onClose: any;
  isOpen: boolean;
  type?: "STUDENT" | "MAIN" | "HEADLINES";
}

export type MenuType = {
  name: string;
  path: string | null;
  Icon?: any;
  type: "category" | "link";
  color: string;
  onClick: () => any;
  id: number;
  isNewTab?: boolean;
  children?: {
    title: string;
    isNewTab: boolean;
    isTitle: number; // 0 = title - 1 = link - 2 = grey link
    path?: string | null;
    onClick: () => any;
  }[];
};
const getSeoData = (queryType: string) =>
  SEO[
    getNameAndEnumForCourseType(queryType)?.name as string
  ]?.keyword?.[0]?.replace(/\s/g, "-");

export const MenusStudent: MenuType[] = [
  {
    id: 1,
    name: "خانه",
    type: "link",
    Icon: Home,
    path: "/",
    color: "#0577AF",
    onClick: () => null,
  },
  {
    id: 2,
    name: "همه دوره‌های من",
    type: "link",
    Icon: BookIcon,
    path: "/student/dashboard",
    color: "#4F9B0B",
    onClick: () => null,
  },
  {
    id: 3,
    name: "اطلاعات‌کاربری",
    color: "#EE8A1E",
    Icon: UserProfileCheckIcon,
    type: "link",
    path: "/student/user-information",
    onClick: () => null,
  },
  // {
  //   id: 4,
  //   name: "دوره‌های پیش رو",
  //   Icon: Courses,
  //   color: "#77268B",
  //   type: "link",
  //   path: "/student/courses/0",
  //   onClick: () => null,
  // },
  // {
  //   id: 5,
  //   name: "دوره‌های پایان یافته",
  //   Icon: CompleteCourses,
  //   color: "#0577AF",
  //   type: "link",
  //   path: "/student/courses/1",
  //   onClick: () => null,
  // },
  {
    id: 6,
    name: "کیف پول",
    Icon: CardCheckIcon,
    color: "#4F9B0B",
    type: "link",
    path: "/student/wallet",
    onClick: () => null,
  },
  {
    id: 7,
    name: "دعوت از دوستان",
    Icon: UsersProfilesPlusIcon,
    color: "#77268B",
    type: "link",
    path: "/student/recommender-code",
    onClick: () => null,
  },
];

export const Menus: MenuType[] = [
  // {
  //   id: 1,
  //   name: "خانه",
  //   type: "link",
  //   path: "/",
  //   color: "#0577AF",
  //   onClick: () => null,
  // },
  {
    id: 3,
    name: "ثبت‌نام دوره‌ها",
    color: "#4F9B0B",
    type: "category",
    children: [
      {
        onClick: () => null,
        isNewTab: false,
        isTitle: 1,
        title: "بسته‌های آموزشی",
        path: `/packages/بسته-های-آموزشی-حقوقی`,
      },
      {
        onClick: () => null,
        title: "آنلاین",
        isNewTab: false,
        isTitle: 1,
        path: `/course-type/${
          getNameAndEnumForCourseType(1)?.name
        }/${getSeoData(getNameAndEnumForCourseType(1)?.name as string)}`,
      },
      {
        onClick: () => null,
        title: "آفلاین",
        isNewTab: false,
        isTitle: 1,
        path: `/package-type/${
          getNameAndEnumForCourseType(2)?.name
        }/بسته-های-حقوقی-آفلاین`,
      },
      {
        onClick: () => null,
        title: "حضوری",
        isNewTab: false,
        isTitle: 1,
        path: `/course-type/${
          getNameAndEnumForCourseType(0)?.name
        }/${getSeoData(getNameAndEnumForCourseType(0)?.name as string)}`,
      },
    ],
    path: "#",
    onClick: () => null,
  },

  {
    id: 10,
    name: "آموزش رایگان",
    children: [
      {
        title: "تصویری",
        path: null,
        isNewTab: false,
        isTitle: 0,
        onClick: () => null,
      },
      {
        title: "دوره رایگان حقوقی",
        isNewTab: false,
        isTitle: 2,
        path: "/course-type/free/دوره-حقوقی-رایگان",
        onClick: () => null,
      },
      {
        title: "لایو",
        isNewTab: false,
        isTitle: 2,
        path: "/posts/لایو-حقوقی",
        onClick: () => null,
      },
      {
        title: "تلویزیونی",
        isNewTab: true,
        isTitle: 2,
        path: "http://farhadbayat.com/videos/",
        onClick: () => null,
      },
      {
        title: "صوتی",
        path: null, //"https://www.old.dadbanan.com/%D9%81%D8%A7%DB%8C%D9%84%e2%80%8c%D9%87%D8%A7%DB%8C-%D8%A2%D9%85%D9%88%D8%B2%D8%B4%DB%8C-%D8%B5%D9%88%D8%AA%DB%8C/",
        isNewTab: false,
        isTitle: 0,
        onClick: () => null,
      },
      {
        title: "پادکست",
        path: "/posts/پادکست-حقوقی",
        isNewTab: false,
        isTitle: 2,
        onClick: () => null,
      },
      {
        title: "رادیویی",
        path: "/posts/فایل-های-رادیویی-حقوقی",
        isNewTab: false,
        isTitle: 2,
        onClick: () => null,
      },
      {
        title: "نوشتاری",
        path: null,
        isNewTab: false,
        isTitle: 0,
        onClick: () => null,
      },
      {
        title: "اخبار",
        path: "/posts/اخبار-حقوقی",
        isNewTab: false,
        isTitle: 2,
        onClick: () => null,
      },
      {
        title: "مقالات",
        path: "/posts/مجله-حقوقی",
        isNewTab: false,
        isTitle: 2,
        onClick: () => null,
      },
      {
        title: "جزوات آموزشی",
        path: "/posts/جزوات-آموزشی-حقوقی",
        isNewTab: false,
        isTitle: 2,
        onClick: () => null,
      },

      // {
      //   title: "مجله حقوقی",
      //   isNewTab: false,
      //   isTitle: 1,
      //   path: "/articles/مجله-حقوقی",
      //   onClick: () => null,
      // },
    ],
    type: "category",
    path: "#",
    color: "#EE8A1E",
    onClick: () => null,
  },
  {
    id: 9,
    name: "فایل‌های کاربردی",
    children: [
      {
        title: "قوانین و مقررات",
        isNewTab: false,
        isTitle: 1,
        path: "/rules/قوانین-و-مقررات",
        onClick: () => null,
      },
      {
        title: "نمونه قراردادها",
        isNewTab: false,
        isTitle: 1,
        onClick: () => null,
        // onClick: () =>
        //   window.open(
        //     "https://www.old.dadbanan.com/%d8%af%d8%a7%d9%86%d9%84%d9%88%d8%af-%d9%86%d9%85%d9%88%d9%86%d9%87-%d9%82%d8%b1%d8%a7%d8%b1%d8%af%d8%a7%d8%af/",
        //     "_blank"
        //   ),
        path: `/posts/نمونه-قرارداد`,
      },
      {
        onClick: () => null,
        isNewTab: false,
        isTitle: 1,
        // onClick: () =>
        //   window.open(
        //     "https://www.old.dadbanan.com/%d8%af%d8%a7%d9%86%d9%84%d9%88%d8%af-%d9%81%d8%b1%d9%85%d9%87%d8%a7%db%8c-%da%a9%d8%a7%d8%b1%d8%a8%d8%b1%d8%af%db%8c/",
        //     "_blank"
        //   ),
        title: "نمونه فرم‌ها/صورت‌جلسات",
        path: `/posts/نمونه-فرم-و-صورتجلسات-شرکت-ها`,
      },
      {
        onClick: () => null,
        isNewTab: false,
        isTitle: 1,
        // onClick: () =>
        //   window.open(
        //     "https://www.old.dadbanan.com/%d8%af%d8%a7%d9%86%d9%84%d9%88%d8%af-%d9%86%d9%85%d9%88%d9%86%d9%87-%d8%a2%d8%b1%d8%a7/",
        //     "_blank"
        //   ),
        title: "نمونه آرای قضایی",
        path: `/posts/نمونه-آرای-قضایی`,
      },
      {
        onClick: () => null,
        isNewTab: false,
        isTitle: 1,
        // onClick: () =>
        //   window.open(
        //     "https://www.old.dadbanan.com/%d8%af%d8%a7%d9%86%d9%84%d9%88%d8%af-%d9%86%d9%85%d9%88%d9%86%d9%87-%d8%a2%d8%b1%d8%a7/",
        //     "_blank"
        //   ),
        title: "نمونه آرای داوری",
        path: `/posts/نمونه-آرای-داوری`,
      },
      {
        onClick: () => null,
        isNewTab: false,
        isTitle: 1,
        title: "لینک‌های کاربردی",
        path: `/posts/لینک-های-کاربردی-حقوقی`,
      },
    ],
    type: "category",
    path: "/rules/قوانین-و-مقررات",
    color: "#77268B",
    onClick: () => null,
  },
  {
    id: 1,
    name: "فرصت‌های شغلی",
    type: "link",
    path: "/jobs",
    color: "#0577AF",
    onClick: () => null,
  },
  // {
  //   id: 4,
  //   name: "خدمات حقوقی",
  //   color: "#4F9B0B",
  //   type: "category",
  //   children: [
  //     {
  //       onClick: () => null,
  //       isNewTab: false,
  //       isTitle: 1,
  //       title: "وکالت",
  //       path: "/attorney/وکالت",
  //     },
  //     {
  //       onClick: () => null,
  //       isNewTab: false,
  //       isTitle: 1,
  //       title: "مشاوره",
  //       path: "/consulting/مشاوره-حقوقی",
  //     },
  //     {
  //       onClick: () => null,
  //       isNewTab: false,
  //       isTitle: 1,
  //       title: "عارضه‌یابی شرکت‌ها",
  //       path: "/problem-finding/عارضه-یابی-حقوقی",
  //     },
  //     {
  //       onClick: () => null,
  //       isNewTab: false,
  //       isTitle: 1,
  //       title: "داوری",
  //       path: "/judgement/داوری",
  //     },
  //     {
  //       onClick: () => null,
  //       isNewTab: false,
  //       isTitle: 1,
  //       title: "امور ثبتی",
  //       path: "/registration-affairs/امور-ثبتی",
  //     },
  //     {
  //       onClick: () => null,
  //       isNewTab: false,
  //       isTitle: 1,
  //       title: "امور اداری",
  //       path: "/administrative-affairs/امور-اداری",
  //     },
  //   ],
  //   path: "#",
  //   onClick: () => null,
  // },
  {
    id: 11,
    name: "انتشارات",
    type: "link",
    path: "http://dadbanandana.com/",
    color: "#EE8A1E",
    onClick: () => null,
  },
  {
    id: 2,
    name: "ارتباط با ما",
    type: "category",
    children: [
      {
        onClick: () => null,
        title: "درباره ما",
        isNewTab: false,
        isTitle: 1,
        path: "/about-us/درباره-دادبانان",
      },
      {
        onClick: () => null,
        title: "تماس با ما",
        isNewTab: false,
        isTitle: 1,
        path: "/contact-us",
      },
      {
        onClick: () => null,
        title: "همکاری با ما",
        isNewTab: true,
        isTitle: 1,
        path: "https://survey.porsline.ir/s/SPdpLw3w",
      },
    ],
    path: "#",
    color: "#77268B",
    onClick: () => null,
  },
  {
    id: 12,
    name: "راهنمای سایت",
    children: [
      {
        title: "فیلم آموزش خرید دوره‌ها",
        isNewTab: false,
        isTitle: 1,
        path: null,
        onClick: () => null,
      },
      {
        title: "فیلم آموزش استفاده از سایت",
        isNewTab: false,
        isTitle: 1,
        path: null,
        onClick: () => null,
      },
      {
        onClick: () => null,
        isNewTab: false,
        isTitle: 1,
        title: "پرسش‌های متداول",
        path: "/faq",
      },
      {
        onClick: () => null,
        isNewTab: false,
        isTitle: 1,
        title: "دانلود اپلیکیشن دادبانان",
        path: "/app-download",
      },
    ],
    type: "category",
    path: "/rules/قوانین-و-مقررات",
    color: "#0577AF",
    onClick: () => null,
  },
];

export const MenusHeadlines: MenuType[] = [
  {
    id: 1,
    name: "داشبورد",
    type: "link",
    path: "/student/dashboard",
    color: "#4F9B0B",
    isNewTab: false,
    onClick: () => null,
  },
  {
    id: 2,
    name: "درس های من",
    color: "#EE8A1E",
    type: "link",
    path: "/student/dashboard",
    isNewTab: false,
    onClick: () => null,
  },
  {
    id: 3,
    name: "فرصت‌های شغلی",
    color: "#77268B",
    type: "link",
    path: "/jobs",
    isNewTab: true,
    onClick: () => null,
  },
];

const CoursesItem = ({ name, id, color, onClose, children }: any) => {
  const [menu, setopenMenu] = useState<"CHILD" | "CATEGORY" | "CLOSE">("CLOSE");
  const [hover, setHover] = useState(false);
  const handleMouseOver = (action: boolean) => {
    setHover(action);
  };

  return (
    <div
      key={id.toString()}
      className="noSelect my-2 flex w-full cursor-pointer flex-col"
    >
      <div
        style={{
          borderColor: color,
          background: hover
            ? `linear-gradient(-90deg, ${color} 10.92%, rgba(79, 155, 11, 0) 86.78%)`
            : "#fff",
        }}
        onClick={() => {
          setTimeout(() => {
            setopenMenu((prev) => (prev == "CATEGORY" ? "CLOSE" : "CATEGORY"));
          }, 100);
        }}
        onMouseEnter={() => handleMouseOver(true)}
        onMouseLeave={() => handleMouseOver(false)}
        className={`flex w-full items-center justify-between border-r-4 fill-current stroke-current py-2 pr-4 text-black hover:text-white`}
      >
        <span>{name}</span>
        <ArrowBottom
          className={cn(
            "mx-4 transform fill-[#4E4E56] font-thin transition-all duration-300",
            menu == "CATEGORY" ? "rotate-180" : "rotate-0"
          )}
        />
      </div>
      {(menu == "CATEGORY" || menu == "CHILD") && (
        <div
          className={`bg-gray-250 noSelect h-auto w-full overflow-hidden  duration-300`}
        >
          <div className="flex w-full animate-fade-in-down flex-col justify-between space-y-2 px-2">
            <ul className="noSelect animate-fade-in-down rounded-b-lg bg-white px-2 pr-5">
              {children}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

const Sidebar: React.FC<SidebarProps> = ({
  onClose,
  type = "MAIN",
  isOpen,
}) => {
  const [isShowVideoModal, setIsShowVideoModal] = useState({
    isShow: false,
    url: "",
  });
  const onShowVideoModal = (data: string) => {
    setIsShowVideoModal({
      isShow: true,
      url: `/videos/${data}.mp4`,
    });
    onClose();
  };
  const [isShowModal, setIsShowModal] = useState(false);
  const [menu, setopenMenu] = useState<"CHILD" | "CATEGORY" | "CLOSE">("CLOSE");

  const router = useRouter();
  const { data, isLoading, isSuccess, isIdle } = useProfile();
  const navbarItem: any =
    type == "HEADLINES"
      ? MenusHeadlines
      : type == "MAIN"
      ? Menus
      : type == "STUDENT" && MenusStudent;

  const handleListItems = (arr: any[], isIdle: boolean) => {
    return isIdle ? arr?.filter((item: any) => item?.name !== "داشبورد") : arr;
  };

  function MouseOver(
    event: React.MouseEvent<HTMLElement>,
    color: string,
    deg: string
  ) {
    // (
    //   event.target as HTMLInputElement
    // ).style.background = `linear-gradient(${deg}, ${color} 10.92%, rgba(79, 155, 11, 0) 86.78%)`;
    (
      event.target as HTMLInputElement
    ).style.background = `linear-gradient(90deg, rgba(53, 176, 185, 0.036) 0.05%, rgba(53, 176, 185, 0.085) 35%, rgba(24, 59, 167, 0.067) 61.67%, rgba(24, 59, 167, 0.1) 94.4%)`;
  }

  function MouseDown(
    event: React.MouseEvent<HTMLElement>,
    color: string,
    deg: string
  ) {
    (
      event.target as HTMLInputElement
    ).style.background = `linear-gradient(${deg}, ${color} 10.92%, rgba(79, 155, 11, 0) 86.78%)`;
  }

  function MouseOut(event: React.MouseEvent<HTMLElement>) {
    (event.target as HTMLInputElement).style.background = "";
  }

  return (
    <>
      <ExitModal {...{ isShowModal, setIsShowModal }} />
      <div onClick={onClose} className={`w-2/12 animate-opacity bg-black/70`} />
      <div className="min-h-screen w-10/12 bg-white pb-[5rem]">
        <div
          className={`h-full overflow-y-scroll pb-10 text-[13px] ${
            menu !== "CLOSE" && "overflow-y-auto"
          }`}
          style={{ zIndex: 60 }}
        >
          <div className="p-4">
            <div className="flex w-full items-center justify-between ">
              <a
                target={"_blank"}
                href="https://dadbanan.com/"
                rel="noreferrer"
              >
                <img
                  loading="lazy"
                  src="/images/logo.png"
                  className="h-9 w-auto object-cover"
                  alt="دادبانان"
                />
              </a>
              <Close
                onClick={onClose}
                className="cursor-pointer fill-gray-450"
              />
            </div>
            <div className="my-4 h-px w-full bg-neutral-200" />
            <div className="flex w-full items-center">
              <div className="flex items-center">
                <Button
                  onClick={() => {
                    router.push("/app-download");
                    onClose();
                  }}
                  CClassName="h-[39px] whitespace-nowrap rounded-[8px] px-6 bg-[#FBCF32] ml-2 text-black"
                >
                  اپ دادبانان
                </Button>
              </div>
            </div>
            <div className="my-4 h-px w-full bg-neutral-200" />
          </div>
          {handleListItems(navbarItem, isIdle)?.map(
            (
              { name, onClick, Icon, color, type, path, id, children }: any,
              index: number
            ) => {
              if (type !== "category") {
                return (
                  <div
                    onMouseEnter={(e) => MouseOver(e, color, "-90deg")}
                    onMouseLeave={MouseOut}
                    key={id.toString()}
                    onClick={() => {
                      onClick() ?? window.open(path, "_blank");
                      setTimeout(() => {
                        onClose();
                      }, 100);
                    }}
                    className={`noSelect flex w-full animate-fade-in-down cursor-pointer flex-col text-black hover:text-blue-600 focus-visible:text-blue-550`}
                  >
                    <div className={`flex items-center py-2 px-4`}>{name}</div>
                  </div>
                );
              } else {
                return (
                  <CoursesItem
                    {...{ id, onClick, name, color, onClose }}
                    key={id.toString()}
                  >
                    {(children as MenuType["children"])?.map(
                      ({ title, isTitle, isNewTab, onClick, path }) => (
                        <li className="" key={id.toString()}>
                          {isTitle > 0 ? (
                            path ? (
                              <a
                                // onMouseEnter={(e) =>
                                //   MouseOver(e, color, "-90deg")
                                // }
                                // onMouseDown={(e) =>
                                //   MouseDown(e, color, "-90deg")
                                // }
                                // onMouseLeave={MouseOut}
                                key={generateUuidForReactList()}
                                className={`block cursor-pointer px-2 py-1 text-black hover:text-blue-600 ${
                                  isTitle === 2 &&
                                  "text-[#808080] hover:text-[#fff]"
                                }`}
                                onClick={() => {
                                  setTimeout(() => {
                                    if (window) {
                                      window.open(path, "_blank")?.focus();
                                    }
                                    onClose();
                                  }, 10);
                                }}
                              >
                                {title}
                              </a>
                            ) : (
                              <a
                                onMouseEnter={(e) =>
                                  MouseOver(e, color, "-90deg")
                                }
                                onMouseDown={(e) =>
                                  MouseDown(e, color, "-90deg")
                                }
                                onMouseLeave={MouseOut}
                                key={generateUuidForReactList()}
                                className={`block cursor-pointer px-2 py-1 ${
                                  isTitle === 2 &&
                                  "text-[#808080] hover:text-[#fff]"
                                }`}
                                onClick={() => onShowVideoModal(title)}
                              >
                                {title}
                              </a>
                            )
                          ) : (
                            <div
                              className="relative my-2 block cursor-default pr-2"
                              onClick={(e) => e.preventDefault()}
                            >
                              <div
                                className="absolute top-0 right-0 h-full w-[1px]"
                                style={{ backgroundColor: color }}
                              />
                              {title}
                            </div>
                          )}
                        </li>
                      )
                    )}
                  </CoursesItem>
                );
              }
            }
          )}

          {!isIdle && (
            <div
              onClick={(e) => {
                setTimeout(() => {
                  onClose(e);
                  setIsShowModal(true);
                }, 100);
              }}
              className="my-2 flex w-full cursor-pointer text-black text-white hover:bg-100 hover:text-blue-600"
              // onMouseEnter={(e) => MouseOver(e, "red", "-90deg")}
              // onMouseLeave={MouseOut}
            >
              <div className={`flex items-center py-2 px-4`}>{"خروج"}</div>
            </div>
          )}
        </div>
      </div>
      <Modal
        visible={isShowVideoModal.isShow}
        onClose={() =>
          setIsShowVideoModal((prev) => ({ ...prev, isShow: true }))
        }
        className="h-screen w-screen"
      >
        <div className="relative mx-auto h-60 w-10/12 rounded bg-black md:h-96 md:w-8/12 xl:h-190">
          <video
            controls
            src={isShowVideoModal.url}
            className="h-full w-full"
          />
          <Close
            onClick={() =>
              setIsShowVideoModal((prev) => ({ ...prev, isShow: false }))
            }
            className="absolute top-5 left-5 cursor-pointer fill-white"
          />
        </div>
      </Modal>
    </>
  );
};

export default Sidebar;
